"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var uploadProfilePicture = function uploadProfilePicture(payload) {
  return {
    type: 'OLY_UPLOAD_PROFILE_PICTURE',
    payload: payload
  };
};

var uploadProfilePictureSuccess = function uploadProfilePictureSuccess() {
  return {
    type: 'OLY_UPLOAD_PROFILE_PICTURE_SUCCESS'
  };
};

var uploadProfilePictureError = function uploadProfilePictureError(error) {
  return {
    type: 'OLY_UPLOAD_PROFILE_PICTURE_ERROR',
    payload: {
      error: error
    }
  };
};

var uploadProfilePictureReset = function uploadProfilePictureReset() {
  return {
    type: 'OLY_UPLOAD_PROFILE_PICTURE_RESET'
  };
};

var _default = {
  uploadProfilePicture: uploadProfilePicture,
  uploadProfilePictureSuccess: uploadProfilePictureSuccess,
  uploadProfilePictureError: uploadProfilePictureError,
  uploadProfilePictureReset: uploadProfilePictureReset
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map